import { Injectable } from '@angular/core';
import { AuthService } from '@app/providers/auth/auth.service';
import { Project, ProjectService } from '@app/providers/projects';
import { EndpointIdentifier, WhitelistCheckResult } from './whitelist.model';
import { CONFIG_MANAGER_V2_WHITELIST } from './whitelist.config';
import * as md5 from 'blueimp-md5';

@Injectable()
export class ConfigManagerWhitelistService {
  private currentUserEmailHash: string | null = null;
  private currentProject: Project | null = null;

  constructor(
    private authService: AuthService,
    private projectService: ProjectService,
  ) {
    this.authService.profile$.subscribe((profile) => {
      if (profile?.email) {
        this.currentUserEmailHash = this.hashEmail(profile.email);
      }
    });

    this.projectService.project$.subscribe((project) => {
      this.currentProject = project;
    });
  }

  isWhitelisted(endpoint: EndpointIdentifier): WhitelistCheckResult {
    if (this.isTeamMember()) {
      return { allowed: true, reason: 'team_member' };
    }

    if (this.isProjectWhitelisted(endpoint)) {
      return { allowed: true, reason: 'project_whitelisted' };
    }

    return { allowed: false, reason: 'not_whitelisted' };
  }

  private isTeamMember(): boolean {
    if (!this.currentUserEmailHash) {
      return false;
    }
    return CONFIG_MANAGER_V2_WHITELIST.teamEmailHashes.includes(
      this.currentUserEmailHash,
    );
  }

  private isProjectWhitelisted(endpoint: EndpointIdentifier): boolean {
    if (!this.currentProject) {
      return false;
    }

    const whitelistedProjects =
      CONFIG_MANAGER_V2_WHITELIST.projectsByEndpoint[endpoint] || [];

    return whitelistedProjects.includes(this.currentProject.short_name);
  }

  private hashEmail(email: string): string {
    const normalized = email.toLowerCase().trim();
    return md5(normalized);
  }
}
